import * as React from "react";
import { DialogContent, Grid, IconButton } from "@mui/material";
import {
    Dialog,
    DialogTitle,
    DialogActions,
    MenuItem,
    TextField,
    FormControlLabel,
    Checkbox,
} from "@mui/material";
import { updateRentDispute } from "state/apis";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { toast } from "react-toastify";
import { Close as CloseIcon } from "@mui/icons-material";

const EditDispute = ({ open, onClose, onSubmit, editData, editMode }) => {
    const theme = useTheme();
    const [data, setData] = React.useState([]);
    const defaultProperty = localStorage.getItem("propertyId");
    const [request, setRequest] = React.useState({
        contractId: null,
        propertyId: null,
        unitId: null,
        isCaseRegistered: "",
        rentAdjustFromDeposit: "",
        amount: 0,
        rentBalance: "",
        deposit: "",
        remarks: "",
        closed: "",
    });
    console.log("request: ", request);

    React.useEffect(() => {
        if (editMode && editData) {
            setRequest((prevData) => ({
                ...prevData,
                contractId: editData.contractId,
                propertyId: editData.propertyId,
                unitId: editData.unitId,
                isCaseRegistered: editData.isCaseRegistered ? "true" : "false",
                rentAdjustFromDeposit: editData.rentAdjustFromDeposit,
                amount: editData.amount,
                rentBalance: editData.rentBalance,
                deposit: editData.deposit,
                remarks: editData.remarks,
                closed: editData.closed,
            }));
        }
    }, [editData, editMode]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setRequest((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        try {
            if (!request?.amount || request?.amount < 0) {
                return toast.error("Please add amount");
            }
            // setRequest((prevData) => ({
            //     ...prevData,
            //     rentBalance: parseInt(request?.rentBalance) - parseInt(req?.amount),
            // }));
            const response = await updateRentDispute(editData.id, {
                ...request,
                rentBalance: parseInt(request?.rentBalance) - parseInt(request?.amount),
            });
            toast.success(response.message);

            setRequest((prevData) => ({
                ...prevData,
                contractId: null,
                propertyId: null,
                unitId: null,
                isCaseRegistered: null,
                amount: 0,
                rentAdjustFromDeposit: "",
                rentBalance: "",
                deposit: "",
                remarks: "",
                closed: "",
            }));
            setData([]);
            onClose();
            onSubmit();
        } catch (error) {
            console.error("Error:", error);
            if (error.response) {
                toast.error(error.response.data.message);
            } else if (error.request) {
                toast.error("No response received from server.");
            } else {
                toast.error("An error occurred. Please try again.");
            }
        }
    };
    const handleDialogClose = () => {
        setRequest({
            contractId: null,
            propertyId: null,
            unitId: null,
            isCaseRegistered: null,
            rentAdjustFromDeposit: 0,
            rentBalance: "",
            deposit: "",
            remarks: "",
            closed: "",
        });
        onClose();
    };
    return (
        <Dialog open={open} onClose={handleDialogClose} fullWidth maxWidth={"md"}>
            {/* <DialogTitle sx={{ textAlign: "center", fontWeight: "900", mb: "2px" }}>
                Receipt
            </DialogTitle> */}
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    marginLeft: "6px",
                }}
            >
                Edit Rent Dispute
                <IconButton onClick={onClose} sx={{ color: "inherit" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3} p={"5px"} mb={"3px"} alignItems="center">
                    <Grid item xs={6}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Property"
                            name="property"
                            value={editData?.property?.propertyName}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Unit"
                            name="unit"
                            value={editData?.unit?.name}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Tenant"
                            name="tenant"
                            value={editData?.contract?.tenant?.name}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Rent Balance"
                            name="rentBalance"
                            value={editData?.rentBalance}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Deposit"
                            name="deposit"
                            value={editData?.deposit}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            select
                            color="primary"
                            fullWidth
                            label="Is Case Registered"
                            name="isCaseRegistered"
                            value={request?.isCaseRegistered}
                            onChange={handleChange}
                        >
                            <MenuItem value="true">Yes</MenuItem>
                            <MenuItem value="false">No</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Amount"
                            name="amount"
                            value={request?.amount}
                            onChange={handleChange}
                        ></TextField>
                    </Grid>
                    <Grid item xs={2}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={request?.closed}
                                    onChange={(e) =>
                                        setRequest({
                                            ...request,
                                            closed: e.target.checked,
                                        })
                                    }
                                    name="closed"
                                    color="primary"
                                />
                            }
                            label="Closed"
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={request?.rentAdjustFromDeposit}
                                    onChange={(e) =>
                                        setRequest({
                                            ...request,
                                            rentAdjustFromDeposit: e.target.checked,
                                        })
                                    }
                                    name="rentAdjustFromDeposit"
                                    color="primary"
                                    disabled={editData?.rentAdjustFromDeposit ? true : false}
                                />
                            }
                            label="Rent Adjust From Deposit"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Remark"
                            variant="outlined"
                            multiline
                            fullWidth
                            color="primary"
                            rows={4}
                            value={editData?.remarks}
                            name="remarks"
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>

                <DialogActions
                    sx={{
                        display: "flex",
                        justifyContent: "end",
                        padding: theme.spacing(2),
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary,
                            backgroundColor: theme.palette.primary[800],
                        }}
                    >
                        Save
                    </Button>
                    {/* <Button
                        variant="contained"
                        // onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        Print
                    </Button> */}
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default EditDispute;
